export default __webpack_public_path__ + "static/media/half-separator.c41663fc.svg";